import * as React from 'react';
import clsx from 'clsx';
import { createStyles } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import { Attention } from '../../../internal/icons/small/Attention';
import { Circle } from '../../../internal/icons/small/Circle';
import { CircleFilled } from '../../../internal/icons/small/CircleFilled';
import { Complete } from '../../../internal/icons/small/Complete';
import { getColor } from '../../styles';
var styles = function (theme) {
    return createStyles({
        root: {
            display: 'flex',
            color: getColor('secondary.main', theme),
        },
        active: {
            color: getColor('brand.main', theme),
        },
        completed: {
            color: getColor('brand.main', theme),
        },
        error: {
            color: getColor('error.main', theme),
        },
    });
};
var iconType = function (props) {
    var active = props.active, activeLabel = props.activeLabel, completed = props.completed, completedLabel = props.completedLabel, error = props.error, errorLabel = props.errorLabel, iconId = props.iconId, incompleteLabel = props.incompleteLabel;
    if (error) {
        return React.createElement(Attention, { id: iconId, className: "js-StepIcon-error", titleAccess: errorLabel });
    }
    if (active) {
        return React.createElement(CircleFilled, { id: iconId, className: "js-StepIcon-active", titleAccess: activeLabel });
    }
    if (completed) {
        return React.createElement(Complete, { id: iconId, className: "js-StepIcon-completed", titleAccess: completedLabel });
    }
    return React.createElement(Circle, { id: iconId, className: "js-StepIcon-unedited", titleAccess: incompleteLabel });
};
export var StepIcon = React.forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function (props, ref) {
    var _a;
    var classes = props.classes, active = props.active, completed = props.completed, error = props.error;
    return (React.createElement("div", { className: clsx(classes.root, (_a = {},
            _a[classes.active] = active,
            _a[classes.completed] = completed,
            _a[classes.error] = error,
            _a)) }, iconType(props)));
});
export default withStyles(styles)(StepIcon);
//# sourceMappingURL=StepIcon.js.map